import { useRef } from "react";
import { UploadCloud, X } from "lucide-react";
import { photoKey } from "../../hooks/useQuoteForm";

export const PhotoUpload = ({ photos, onAdd, onRemove }) => {
  const fileRef = useRef(null);

  const pick = (e) => {
    onAdd(Array.from(e.target.files || []));
    e.target.value = "";
  };

  return (
    <>
      <button
        type="button"
        data-testid="quote-form-file-upload"
        onClick={() => fileRef.current?.click()}
        className="w-full border-2 border-dashed border-zinc-300 rounded-xl p-6 flex flex-col items-center gap-2 text-zinc-500 hover:border-[#FF2A2A] hover:text-[#FF2A2A] transition-colors duration-200"
      >
        <UploadCloud size={26} />
        <span className="text-sm font-medium">Tap to add photos of your vehicle or space</span>
      </button>
      <input ref={fileRef} type="file" accept="image/*" multiple hidden onChange={pick} />
      {photos.length > 0 && (
        <div data-testid="quote-form-photo-previews" className="mt-4 flex flex-wrap gap-3">
          {photos.map((p, i) => (
            <div key={photoKey(p)} className="relative w-20 h-20 rounded-lg overflow-hidden border border-zinc-200">
              <img src={URL.createObjectURL(p)} alt={p.name} className="w-full h-full object-cover" />
              <button
                type="button"
                data-testid={`quote-photo-remove-${i}`}
                onClick={() => onRemove(i)}
                className="absolute top-1 right-1 w-5 h-5 rounded-full bg-black/70 text-white flex items-center justify-center"
                aria-label={`Remove photo ${i + 1}`}
              >
                <X size={12} />
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );
};
